
export enum ApplicationRegion {
    Infra = 'infra',
    AU = 'au',
    UK = 'uk',
    NZ = 'nz',
    CA = 'ca',
    US = 'us'
}